import React from 'react';

/*
 * ButtonSpinner — Button-internal loading-state spinner.
 *
 * Figma source: 24x24 frame, with 8 white ellipses arranged in a circle inside
 * a centered 16x16 group. Dot sizes graduate from 1.39px to 4.17px — the
 * largest dot at top, sizes decrement going clockwise (visual cue for rotation
 * direction). Renders identically to Figma's static loading-state PNG export.
 *
 * Animation: rotates 360° / 1s linear infinite. Figma shows a single frame;
 * we add the rotation so the button feels "loading" in real use. Animation is
 * suppressed in the visual regression harness via the `* { animation: none }` CSS
 * blanket applied by the framework, so static comparison still passes.
 *
 * Coordinates lifted from Figma's `Group 1` inside `Spinner` instance
 * (the Figma source.json).
 * Group origin offset by (4, 4) from spinner frame; positions translated below.
 */
export const ButtonSpinner: React.FC = () => (
  <svg
    className="hd-btn-spinner"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
    style={{ overflow: 'visible' }}
  >
    {/* 8 dots — center positions translated to 24x24 viewport (add group offset 4,4 then dot half-w). */}
    <circle cx="12" cy="6.087" r="2.087" fill="currentColor" />
    <circle cx="17.565" cy="8.870" r="1.391" fill="currentColor" />
    <circle cx="18.957" cy="13.391" r="1.043" fill="currentColor" />
    <circle cx="17.391" cy="17.739" r="0.870" fill="currentColor" />
    <circle cx="12" cy="19.304" r="0.696" fill="currentColor" />
    <circle cx="6.609" cy="17.739" r="0.870" fill="currentColor" />
    <circle cx="5.043" cy="13.391" r="1.043" fill="currentColor" />
    <circle cx="6.609" cy="8.696" r="1.565" fill="currentColor" />
    <style>{`
      @keyframes hd-btn-spinner-rotate {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
      .hd-btn-spinner {
        transform-origin: center;
        animation: hd-btn-spinner-rotate 1s linear infinite;
      }
    `}</style>
  </svg>
);
